AFRAME.registerComponent('nearby-reveal', {
    schema: {
        radius: {
            type: 'number',
            default: 1
        },
        target: {
            type: 'selector'
        },
        animate: {
            type: 'boolean',
            default: true
        }
    },
    init: function () {
        this._nearby = false;
        this.cameraPosition = new THREE.Vector3();
        this.position = new THREE.Vector3();
        if (this.data.animate) {
            this.el.setAttribute('visible', false);
        }
    },
    tick: function () {
        const radius = this.data.radius;

        this.el.object3D.getWorldPosition(this.position);
        document.querySelector('[camera]').object3D.getWorldPosition(this.cameraPosition);
        const dx = this.position.x - this.cameraPosition.x;
        const dz = this.position.z - this.cameraPosition.z;
        let nearby = false;
        if (dx * dx + dz * dz < radius * radius) {
            nearby = true;
        }
        
        if (nearby != this._nearby) {
            if (nearby) {
                if (this.data.target) {
                    const src = this.el.getAttribute('src');
                    if (src.indexOf("#thumbnail-") == 0) {
                        this.el.setAttribute('src', '#' + src.substring(11));
                    }
                    if (!this.data.target.classList.contains('videostarted')) {
                        this.data.target.currentTime = 0;
                        this.data.target.classList.add('videostarted');
                        // Hack for MacOS Safari
                        this.data.target.classList.add('muststartvideo');
                    }
                    this.data.target.play().then(() => {
                        // Nothing to do
                    }, () => {
                        console.error("The video cannot be started");
                    })
                }
                if (this.data.animate) {
                    this.el.setAttribute('visible', true);
                    this.el.setAttribute('animation', 'property: scale; to: 1 1 1; dur: 500; easing: easeInOutQuad; loop: false');
                }
            }
            this._nearby = nearby;
        }
    },
});